import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import styles from './action-button.scss';
export class ActionButton extends React.Component {
  render() {
    const {
      rounded,
      children,
      className,
      onClick,
      isFocusable,
      ariaLabel,
      dataHook
    } = this.props;
    const styleNames = classnames(className, styles['action-button'], {
      [styles.rounded]: rounded
    });
    return /*#__PURE__*/React.createElement("button", {
      className: styleNames,
      onClick: onClick,
      tabIndex: onClick && isFocusable ? 0 : -1,
      "data-hook": dataHook,
      "aria-label": ariaLabel
    }, children);
  }
}
_defineProperty(ActionButton, "defaultProps", {
  rounded: false,
  isFocusable: true
});
//# sourceMappingURL=action-button.js.map